
(() => {
  const sections = [];
  let ticking = false;
  let rebuildTimer = null;
  const reduceMotionQuery =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
  const smoothstep = (t) => t * t * (3 - 2 * t);
  const reduceMotion = () => !!(reduceMotionQuery && reduceMotionQuery.matches);

  const applyHeaderHeight = () => {
    const header = document.querySelector(
      '.section-header, .shopify-section-group-header-group, header'
    );
    const height = header ? Math.round(header.getBoundingClientRect().height) : 0;

    document.querySelectorAll('.cd-home-refills').forEach((section) => {
      section.style.setProperty('--cd-home-header-height', `${height}px`);
    });
  };

  function buildLine() {
    const line = document.createElement('span');
    line.className = 'cd-refills-line';
    line.setAttribute('aria-hidden', 'true');
    return line;
  }

  function buildInner(text) {
    const inner = document.createElement('span');
    inner.className = 'cd-refills-line__text';
    inner.textContent = text;
    return inner;
  }

  function splitRenderedLines(node, text) {
    const words = text.split(/\s+/).filter(Boolean);
    if (!words.length) return text ? [text] : [];

    node.textContent = '';

    const spans = words.map((word, index) => {
      const span = document.createElement('span');
      span.textContent = index === words.length - 1 ? word : `${word} `;
      span.style.display = 'inline-block';
      span.style.whiteSpace = 'pre';
      node.appendChild(span);
      return span;
    });

    const lines = [];
    let current = [];
    let currentTop = null;

    spans.forEach((span) => {
      const top = span.offsetTop;
      if (currentTop === null) currentTop = top;
      if (Math.abs(top - currentTop) > 2 && current.length) {
        lines.push(current.join('').trim());
        current = [];
        currentTop = top;
      }
      current.push(span.textContent || '');
    });

    if (current.length) lines.push(current.join('').trim());
    node.textContent = '';
    return lines.length ? lines : [text];
  }

  function buildLineflow(root) {
    root.querySelectorAll('[data-cd-refills-lineflow]').forEach((node) => {
      let original = node.getAttribute('data-cd-refills-original');
      if (!original) {
        original = (node.innerHTML || '').trim();
        node.setAttribute('data-cd-refills-original', original);
      }

      const segments = original
        .replace(/<br\s*\/?>/gi, '\n')
        .split('\n')
        .map((part) => part.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim())
        .filter(Boolean);

      if (!segments.length) {
        segments.push((node.textContent || '').replace(/\s+/g, ' ').trim());
      }

      node.setAttribute('aria-label', segments.join(' '));
      node.innerHTML = '';

      let lineIndex = 0;
      segments.forEach((segment) => {
        splitRenderedLines(node, segment).forEach((lineText) => {
          const line = buildLine();
          line.style.setProperty('--cd-refills-line-index', String(lineIndex));
          line.appendChild(buildInner(lineText));
          node.appendChild(line);
          lineIndex += 1;
        });
      });
    });
  }

  const getOrCreateSection = (section) => {
    const existing = sections.find((entry) => entry.root === section);
    if (existing) return existing;

    const entry = {
      root: section,
      blocks: Array.from(section.querySelectorAll('[data-cd-refills-block]')),
    };

    buildLineflow(section);
    sections.push(entry);
    return entry;
  };

  const resetSection = (entry) => {
    entry.blocks.forEach((block) => block.classList.add('is-visible'));
  };

  const updateSection = (entry) => {
    if (!entry || !entry.root) return;

    if (reduceMotion()) {
      resetSection(entry);
      return;
    }

    const rect = entry.root.getBoundingClientRect();
    const viewportHeight = window.innerHeight || 1;
    const overall = clamp((viewportHeight - rect.top) / (viewportHeight + rect.height), 0, 1);
    const progress = smoothstep(clamp((overall - 0.2) / 0.54, 0, 1));

    entry.blocks.forEach((block) => {
      if (block.classList.contains('is-visible')) return;
      const step = parseFloat(block.getAttribute('data-cd-refills-step') || '0') || 0;
      const threshold = 0.02 + step * 0.1;
      if (progress >= threshold) {
        block.classList.add('is-visible');
      }
    });
  };

  const updateAll = () => {
    sections.forEach(updateSection);
    ticking = false;
  };

  const queueUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateAll);
  };

  const init = (context = document) => {
    context.querySelectorAll('[data-cd-refills-motion]').forEach(getOrCreateSection);
    applyHeaderHeight();
    queueUpdate();
  };

  const rebuildAll = () => {
    sections.forEach((entry) => {
      if (!entry || !entry.root) return;
      buildLineflow(entry.root);
    });
    queueUpdate();
  };

  document.addEventListener('DOMContentLoaded', () => init(document));
  window.addEventListener('load', () => {
    init(document);
    rebuildAll();
  });
  window.addEventListener('resize', () => {
    applyHeaderHeight();
    clearTimeout(rebuildTimer);
    rebuildTimer = window.setTimeout(rebuildAll, 140);
    queueUpdate();
  });
  window.addEventListener('scroll', queueUpdate, { passive: true });
  window.addEventListener('orientationchange', () => {
    clearTimeout(rebuildTimer);
    rebuildTimer = window.setTimeout(rebuildAll, 140);
    queueUpdate();
  });

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target || document);
    rebuildAll();
  });

  if (reduceMotionQuery && typeof reduceMotionQuery.addEventListener === 'function') {
    reduceMotionQuery.addEventListener('change', rebuildAll);
  }

  window.CDHomeRefills = {
    init,
    refresh: queueUpdate,
    rebuild: rebuildAll,
  };
})();
